import { Transform, Type } from "class-transformer";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { UserDto } from "@/core/features/users/user.dto";
import { parseApiDate } from "@/utils/dates/dateFormats";

export class UserSessionDto extends BaseEntityDto {
  @Type(() => UserDto)
  user?: UserDto;
  userId: string;

  device?: string;
  userAgent?: string;
  ipAddress?: string;
  countryCode?: string;
  countryName?: string;

  @Transform(({ value }) => parseApiDate(value))
  lastActivity: Date;

  @Transform(({ value }) => parseApiDate(value))
  expiresAt: Date;

  active: boolean;

  toString(): string {
    return `${this.device || "Unknown device"} - ${this.ipAddress || "Unknown IP"}`;
  }

  get isExpired(): boolean {
    return this.expiresAt < new Date();
  }

  get countryInfo(): string {
    if (this.countryName && this.countryCode) {
      return `${this.countryName} (${this.countryCode})`;
    }

    return this.countryName || this.countryCode || "España (ES)";
  }

  get deviceInfo(): string {
    if (this.device) return this.device;
    if (this.userAgent) {
      // Extract simple device info from user agent
      if (this.userAgent.includes("Mobile")) return "Mobile";
      if (this.userAgent.includes("Tablet")) return "Tablet";
      if (this.userAgent.includes("Windows")) return "Windows PC";
      if (this.userAgent.includes("Mac")) return "Mac";
      if (this.userAgent.includes("Linux")) return "Linux";
    }
    return "Unknown";
  }
}
